// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Enq1","label":"CategoryService_label__29gAn","location":"CategoryService_location__39QuU"};